import { LoadingButton } from '@mui/lab'
import { Backdrop, Box, Button, CircularProgress, FormControl, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, Switch, TextField, Typography } from '@mui/material'
import { debounce } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useAuthContext } from 'src/auth/useAuthContext'
import CustomInput from 'src/components/customerinput/CustomerInput'
import CustomModal from 'src/components/customerinput/CustomModal'
import { notify } from 'src/components/notify'
import getMetaAccountsNumbers from 'src/services/campian/getMetaAccountsNumbers'
import verifyMetaNumber from 'src/services/campian/createNumberVerify'
import createMessageEnabled from 'src/services/campian/createMessageEnabled'
import updateCampianAssignGroup from 'src/services/campian/updateAssignNumber'
import getCampianGroups from 'src/services/campian/getGroupData'
export default function AccountsNumbers({ open, close, editData, setReload }) {
    const { user } = useAuthContext()
    const [numbers, setNumbers] = useState([])
    const [pin, setPin] = useState("")
    const [values, setValues] = useState({
        display_name: "",
        display_number: "",
        phone_number_id: "",
        waba_id: "",
        group: "",
        msg_limit: "",
        quality_rating: "medium"
    })
    const [loading, setLoading] = useState(false)
    const handleSubmit = async (editData) => {
        try {
            const newData = {
                display_name: editData.display_name,
                display_number: editData.display_number,
                phone_number_id: editData.phone_number_id,
                waba_id: editData.waba_id,
                group: values.group,
                msg_limit: +values.msg_limit,
                quality_rating: editData.quality_rating
            }

            if (!newData.group) {
                return notify('Group is required.')
            }
            if (!newData.quality_rating) {
                return notify('Quality rating is required.')
            }
            if (!newData.msg_limit) {
                return notify('Message limit is required.')
            }


            setLoading(true)
            let data;
            data = await updateCampianAssignGroup(user, { ...newData }, editData?._id)
            if (data) {
                notify("Created Successfully.", "success")
                setReload((prev) => !prev)
                close()
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false)
        }


    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoadingBack(true)
                const response = await getMetaAccountsNumbers(user, editData.id)
                setNumbers(response || [])
                setValues((prev) => {
                    return {
                        ...prev,
                        group: response[0]?.group || "",
                        msg_limit: response[0]?.msg_limit || "",
                    }
                })

            } catch (err) {
                console.log(err);
            } finally {
                setLoadingBack(false)
            }
        }
        fetchData()
    }, [open])
    const [verify, setVerify] = useState(false)
    const [enableMsg, setEnableMsg] = useState(false)
    const [loadingBack, setLoadingBack] = useState(false)
    const VerifyNumber = async (check, data) => {
        try {
            if (check) {
                if (pin.length != 6) {
                    return notify("Pin should be 6 character")
                }
                setLoadingBack(true)
                const response = await verifyMetaNumber(user, data.phone_number_id, pin)
                if (response) {
                    setVerify(true)
                    notify("Verify successfully", "success")
                    setReload((prev) => !prev)
                    close()
                }
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoadingBack(false)

        }
    }

    const [number, setNumber] = useState("")
    const enableMessage = async (check, data) => {
        try {
            if (check) {
                if (number.length != 10) {
                    return notify("Mobile number should be 10 digits")
                }
                setLoadingBack(true)
                const response = await createMessageEnabled(user, data.phone_number_id, number)
                if (response) {
                    setEnableMsg(true)
                    notify("Message Enabled successfully", "success")
                    setReload((prev) => !prev)
                    close()
                }
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoadingBack(false)

        }
    }

    const [groupName, setGroupName] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianGroups(user, 0, 10000)
            setGroupName(data?._payload || [])
        }
        fetchData()
    }, [])
    const handleChange = (e) => {
        const { name, value } = e.target
        setValues((prev) => {
            return {
                ...prev,
                [name]: value

            }

        })
    }


    return (
        <div>

            <CustomModal open={open} close={close} heading={"Meta Account Numbers"}>
                {loadingBack && <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000000 }}
                    open={loadingBack}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>}

                <Stack spacing={1}>

                    {
                        (numbers.length == 0 && !loadingBack) && <Typography>Number not found...</Typography>
                    }
                    {
                        numbers?.map((it, index) => {
                            return (
                                <Paper sx={{ padding: "10px", border: "1px solid lightGrey" }} key={index}>
                                    <Stack spacing={1}>
                                        <Stack direction="row" justifyContent="space-between">
                                            <Typography variant="body1">Display Name</Typography>
                                            <Typography variant="body1">{it?.display_name}</Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between">
                                            <Typography variant="body1">Display Number</Typography>
                                            <Typography variant="body1">{it?.display_number}</Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between">
                                            <Typography variant="body1">Quality Rating</Typography>
                                            <Typography variant="body1">{it?.quality_rating}</Typography>
                                        </Stack>
                                        <Stack direction="row" justifyContent="space-between">
                                            <Typography variant="body1">Message Limit</Typography>
                                            <Typography variant="body1">{it?.msg_limit}</Typography>
                                        </Stack>
                                        {it.verification_status == "VERIFIED" && <Stack direction="row" justifyContent="space-between">
                                            <Typography variant="body1">Status</Typography>
                                            <Typography variant="body1" color="primary">VERIFIED</Typography>
                                        </Stack>}
                                        {it.verification_status != "VERIFIED" && <Stack >
                                            <Stack direction="row" justifyContent="space-between">
                                                <Typography variant="body1" color="primary">Verify</Typography>
                                                <Switch checked={verify} onChange={(e) => VerifyNumber(e.target.checked, it)} />
                                            </Stack>
                                            <CustomInput label="Pin" input={
                                                <TextField fullWidth placeholder='Enter Pin'
                                                    inputProps={{ maxlength: 6 }}
                                                    value={pin}
                                                    onChange={(e) => setPin(e.target.value)}
                                                />
                                            } />
                                        </Stack>}
                                        {it.verification_status == "VERIFIED" && <Stack mb={2}>
                                            <CustomInput
                                                label="Group Name"
                                                input={
                                                    <Select select fullWidth placeholder='Enter group name.' size="small"
                                                        value={values?.group}
                                                        onChange={handleChange}
                                                        name='group'
                                                        displayEmpty
                                                    >
                                                        <MenuItem value="">Select Group name</MenuItem>
                                                        {
                                                            groupName.map((it) => {
                                                                return (
                                                                    <MenuItem key={it?._id} value={it?._id}>{it?.name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                }
                                            />
                                            {!it.msg_limit && <CustomInput
                                                label="Message limit"
                                                input={
                                                    <TextField fullWidth placeholder='Enter message limit.' size="small"
                                                        value={values?.msg_limit}
                                                        onChange={handleChange}
                                                        name='msg_limit'
                                                    />
                                                }
                                            />}
                                            <Stack direction="row" justifyContent="flex-end" mt={1}>
                                                <LoadingButton loading={loading} disabled={loading} size='small' variant="contained" onClick={() => handleSubmit(it)}>Save</LoadingButton>
                                            </Stack>
                                        </Stack>}
                                        {(!it.message_enabled && it.verification_status == "VERIFIED") && <Stack >
                                            <Stack direction="row" justifyContent="space-between">
                                                <Typography variant="body1" color="primary">Message Enable</Typography>
                                                <Switch checked={enableMsg} onChange={(e) => enableMessage(e.target.checked, it)} />
                                            </Stack>
                                            <CustomInput label="Phone Number" input={
                                                <TextField fullWidth placeholder='Enter mobile number'
                                                    inputProps={{ maxlength: 10 }}
                                                    value={number}
                                                    onChange={(e) => setNumber(e.target.value)}
                                                />
                                            } />
                                        </Stack>}
                                    </Stack>
                                </Paper>
                            )
                        })
                    }
                </Stack>
            </CustomModal>
        </div>
    )
}
